<template>
    <v-layout class="fill-height">
        <v-container
            id="contentDashboard" fluid
            class="fill-height"
        >
        
            <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            app
            >
            {{snackbarText}}
            <v-btn
                text
                dark
                @click="snackbar = false"
            >
                Fermer
            </v-btn>
            </v-snackbar>
            <v-layout>
            <v-row
                align="start"
                justify="start"
            >
                <v-col cols="12" class="pt-1">
                    <header-sidebar></header-sidebar>
                    <v-card class="table-content">
                        <v-card-title>
                            <div class="text-left">
                                <span style="font-weight:700; font-size: 18px;">Gestion des Privilèges</span>
                            </div>
                        </v-card-title>
                        <v-card-text class="text-left">
                            <v-row>
                                <v-col cols="12" md="4">
                                    Classe d'utilisateurs
                                    
                                    <v-list>
                                        <v-list-item-group
                                            v-model="permission_classes"
                                            mandatory
                                            color="primary"
                                        >
                                            <v-list-item v-for="(row,key) in classes" @click="getClass(row.id)" v-bind:key="key">

                                            <v-list-item-content>
                                                <v-list-item-title>{{row.titre}}</v-list-item-title>
                                                
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn  :disabled="row.id == 1"  @click="editable = !editable" icon>
                                                    <v-icon color="primary lighten-1">mdi-pencil</v-icon>
                                                </v-btn>
                                                <v-btn :disabled="row.id == 1" icon>
                                                    <v-icon color="error lighten-1">mdi-delete</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <p style="font-size: 16px;">Privilèges</p>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="add_dossier" input-value="true" class="privilege-checkbox" label="Ajouter Dossier" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="edit_dossier" input-value="true" label="Editer Dossier" class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="delete_dossier" label="Supprimer Dossier"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="add_avis" input-value="true" class="privilege-checkbox" label="Ajouter Avis" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="edit_avis" input-value="true" label="Editer Avis" class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="delete_avis" label="Supprimer Avis"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="add_facture" input-value="true" class="privilege-checkbox" label="Ajouter Facture" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="edit_facture" label="Editer Facture"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="delete_facture" label="Supprimer Facture"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="add_client" input-value="true" class="privilege-checkbox" label="Ajouter Client" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="edit_client" label="Editer Client"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="delete_client" label="Supprimer Client"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="browse_database" input-value="true" class="privilege-checkbox" label="Accès Base De Données" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" :value="['add_database','edit_database']" label="Ajouter/Editer"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="delete_database" label="Supprimer"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="log" input-value="true" class="privilege-checkbox" label="Accès Log" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="statistique" label="Accès Statistique"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="website_edit" input-value="true" label="Gestion Interface Web"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="" input-value="true" label="Paramètres"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-checkbox hide-details v-model="permission" value="browse_users" input-value="true" label="Gestion Utilisateurs"  class="privilege-checkbox" :disabled="!editable"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            </v-layout>
        </v-container>
    </v-layout>
</template>
    
<script>
    import headerSidebar from '../commons/header_sidebar.component'

    export default {
        name: 'manage-privilege',
        data: () => ({
          snackbar: false,
          color: 'error',
          snackbarText: '',
          editable: false,
          permission_classes: null,
          permission: [],
          classes: []
        }),
        components: {headerSidebar},
        mounted() {
            this.axios
                .get("/users/permissions/list")
                .then(res => {
                    this.classes = res.data
                })
            this.getClass(1)
        },
        methods: {
            getClass(id){
                this.axios
                .get("/users/permission/"+id)
                .then(res => {
                    this.permission = res.data
                })
            }
        }
    } 
</script>
<style lang="scss" scoped>
 .privilege-checkbox >>> .v-label {
     font-size:12px;
 }
 .v-data-table >>> .text-start{
    height:65px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/users/privilege.vue